<template>
    <div id="tablePrint">
        <b-table
            show-empty
            responsive
            :items="data"
            :fields="fields"
            class="scroll-bar-pop text-center"
            empty-text="ไม่มีข้อมูล"
            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
        >
            <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
            <template slot="status" slot-scope="row">
                <b-badge :variant="statusCancel( row.item.status ).color">
                    {{ statusCancel( row.item.status ).status }}
                </b-badge>
            </template>
            <template slot="tracking_code" slot-scope="row">
                {{(row.item.tracking_code) ? row.item.tracking_code : '-'}}
            </template>
            <template slot="dimension" slot-scope="row">
                <template
                  v-if="row.item.dimension.width + row.item.dimension.length + row.item.dimension.height <= 3">
                  -
                </template>
                <template v-else>
                  {{row.item.dimension.width+'x'+row.item.dimension.length+'x'+row.item.dimension.height}}
                </template>
            </template>
            <template slot="weight" slot-scope="row">
                {{ (row.item.weight) ? ( ( $THEME.unitKG ) ? (row.item.weight / 1000) : row.item.weight ) : '-'}}
            </template>
        </b-table>
    </div>
</template>

<script>
import { statusCancel } from "@/plugins/statusCancel.js"
import configPOPTheme from '@/config/POPTheme'
export default {
    props:{
        data: Array ,
    },
    data() {
        return {
            statusCancel: statusCancel
        }
    },
    computed:{
        fields(){
            let fields = [
                { key: "index", label: "#", sortable: true },
                { key: "date_time_cancel", label: "วันที่เวลายกเลิก", sortable: true },
                { key: "receipt_no", label: "รหัสรายการ", sortable: true },
                { key: "tracking_code", label: "หมายเลขติดตามพัสดุ", sortable: true },
                { key: "status", label: "สถานะ", sortable: true },
                { key: "item_name", label: "ชื่อขนส่ง", sortable: true },
                { key: "dimension", label: "ขนาดพัสดุ", sortable: true },
                { key: "weight", label: ( this.$THEME.unitKG ) ? 'น้ำหนัก (กิโลกรัม)':'น้ำหนัก (กรัม)', sortable: true },
                { key: "remark", label: "เหตุผลในการยกเลิก", sortable: true }
            ]
            return fields
        }
    }
}
</script>
